type Country = {
  id: number;
  name: string;
  alpha2code: string;
};

export const findCountryMatch = (
  extractedCountry: string | undefined | null,
  countries: Country[],
): Country | undefined => {
  if (!extractedCountry || countries.length === 0) {
    return undefined;
  }

  const extractedCountryLowerCase = extractedCountry.trim().toLowerCase();

  // 1. Exact match on alpha2code (case-insensitive)
  const alpha2ExactMatch = countries.find(
    (c) => c.alpha2code.toLowerCase() === extractedCountryLowerCase,
  );
  if (alpha2ExactMatch) return alpha2ExactMatch;

  // 2. Exact match on name (case-insensitive)
  const nameExactMatch = countries.find(
    (c) => c.name.toLowerCase() === extractedCountryLowerCase,
  );
  if (nameExactMatch) return nameExactMatch;

  // 3. Partial match on alpha2code (only for short inputs like "USA" → "US")
  if (extractedCountryLowerCase.length <= 4) {
    const alpha2PartialMatch = countries.find(
      (c) =>
        c.alpha2code.toLowerCase().includes(extractedCountryLowerCase) ||
        extractedCountryLowerCase.includes(c.alpha2code.toLowerCase()),
    );
    if (alpha2PartialMatch) return alpha2PartialMatch;
  }

  // 4. Partial match on name (extracted contains name or name contains extracted)
  const namePartialMatch = countries.find(
    (c) =>
      c.name.toLowerCase().includes(extractedCountryLowerCase) ||
      extractedCountryLowerCase.includes(c.name.toLowerCase()),
  );
  if (namePartialMatch) return namePartialMatch;

  return undefined;
};
